import React, { useContext } from 'react';
import '../../styles/site.css';
import Session from './Session';
import equalarray from '../../tools/EqualArray';
import Context from './SessionProvider';

const Header = (props) => {
    const { user } = useContext(Context);
    
    return (
        <>
            {props.session !== undefined ? (
                <nav className="navbar navbar-expand-lg navbar-light" style={{ padding: 0 }} id="navbar-master">

                    <div className='col-md-2'>

                    </div>
                    <div className='col-md-10'>
                        <Session></Session>
                    </div>
                </nav>)
                : (
                <nav className="navbar-master" id="navbar-master">
                    <div className='col-md-12'>
                    </div>
                </nav>
                )
            }
        </>
    )
}

/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
    // console.log(equalarray(prevProps.poliza, nextProps, (prevProps.value === nextProps.value), (JSON.stringify(prevProps.poliza[0]) === JSON.stringify(nextProps.poliza[0]))); 
    //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
    //falso es igual que son diferentes
    //si son muchos objetos va si [0]
    return (equalarray(prevProps, nextProps));
}

export default React.memo(Header, validaProps);